import React, { useEffect, useState } from 'react'
import { IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import Drawer from "@mui/material/Drawer";
import theme from "../../../../data/theme";
import LogoutIcon from '@mui/icons-material/Logout';

// Icons
import EventIcon from '@mui/icons-material/Event';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import PersonIcon from '@mui/icons-material/Person';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

import { RotasSideBar as rotas } from '../components/RotasSideBar'
import { Link, useLocation, useNavigate } from "react-router-dom";

import { styled } from "@mui/material/styles";
import { decryptCryptoJs } from '../../../../Helper/crypto';
import { apiAtualizaDados } from '../../../../api/apiAtualizarDados';
import { useModalGenerico } from '../../../../contexts/ModalContext';

const SideBarBase = ({ open, handleDrawerToggle, setOpen, isMobile }) => {

    const [isManager, setIsManager] = useState("");
    const location = useLocation();
    const navigate = useNavigate();
    const { mostraMensagem } = useModalGenerico();


    useEffect(() => {
        ensureLogin()
    }, [location.pathname]);

    const ensureLogin = async () => {

        const EncryptedStorage = localStorage.getItem('RL774DLxRi9E');
        if (!EncryptedStorage) { navigate('/login') }

        try {
            const decriptedStorage = await decryptCryptoJs(EncryptedStorage);
            const jsonStorage = await JSON.parse(decriptedStorage);
            const rolesValues = Object.values(jsonStorage.roles);
            setIsManager(rolesValues.includes('ROLE_MANAGER'))
            //console.log('É admin : ', rolesValues.includes('ROLE_MANAGER'))
        } catch (err) {
            setIsManager(false)
        }

    }

    const handleDeslogar = async () => {
        localStorage.removeItem('RL774DLxRi9E');
        navigate('/login');
    }

    const atualizaDados = async () => {
        try {
            const res = await apiAtualizaDados();
            if (res.status === 200) {
                // console.log("res", res)
                mostraMensagem(
                    <>
                        📩 Confira sua caixa de entrada! <br /> Enviamos as informações para o seu e-mail.
                    </>)
            }
        } catch (error) {
            console.error('Erro ao tentar atualizar dados', error);
        }
    }

    const abreManual = () => {
        window.open(`${process.env.REACT_APP_URL_CREDENCIAL}/private/docs/Manual_do_Associado_Ascoprel`)
    }

    return (
        <Drawer
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                "& .MuiDrawer-paper": { width: isMobile ? '100%' : drawerWidth, boxSizing: "border-box" },
            }}
            variant="persistent"
            anchor="left"
            open={open}
        >
            <DrawerHeader>
                <IconButton onClick={handleDrawerToggle}>
                    {theme.direction === "ltr" ? (
                        <ChevronLeftIcon />
                    ) : (
                        <ChevronRightIcon />
                    )}
                </IconButton>
            </DrawerHeader>
            <List>
                {rotas.map((item) => (
                    <React.Fragment key={item.full_name}>
                        {item.children.map((rota) => (
                            <ListItem key={rota.name} disablePadding sx={{ display: "block" }}>
                                <ListItemButton
                                    sx={
                                        location.pathname.includes(rota.pathSelected)
                                            ? {
                                                minHeight: 48, px: 2.5,
                                                justifyContent: open ? "initial" : "center",
                                                bgcolor: "#2A307D", borderRadius: "0 15px 15px 0",
                                                "&:hover": { bgcolor: "#2A307D" },
                                            }
                                            : { minHeight: 48, justifyContent: open ? "initial" : "center", px: 2.5 }
                                    }
                                    component={Link} to={rota.path}
                                    onClick={() => {
                                        if (isMobile) {
                                            setOpen(false)
                                        }
                                    }}
                                >
                                    <ListItemIcon
                                        sx={
                                            location.pathname.includes(rota.pathSelected)
                                                ? { minWidth: 0, mr: open ? 3 : "auto", justifyContent: "center", color: "white", }
                                                : { minWidth: 0, mr: open ? 3 : "auto", justifyContent: "center" }
                                        }
                                    >
                                        {rota.icon}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={rota.name}
                                        sx={
                                            location.pathname.includes(rota.pathSelected)
                                                ? { fontWeight: "bold", color: "white", opacity: open ? 1 : 0 }
                                                : { color: theme.palette.common.black, opacity: open ? 1 : 0 }
                                        }
                                    />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </React.Fragment>
                ))}

                {isManager &&
                    <>
                        {/* Rota Gestor */}
                        <hr />
                        <ListItem disablePadding sx={{ display: "block" }}>
                            <ListItemButton
                                sx={
                                    '/private/gestor/solicitacoesPendentes' === location.pathname
                                        ? {
                                            minHeight: 48, px: 2.5,
                                            justifyContent: open ? "initial" : "center",
                                            bgcolor: "#2A307D", borderRadius: "0 15px 15px 0",
                                            "&:hover": { bgcolor: "#2A307D" },
                                        }
                                        : { minHeight: 48, justifyContent: open ? "initial" : "center", px: 2.5 }
                                }
                                component={Link} to={'/private/gestor/solicitacoesPendentes'}
                                onClick={() => {
                                    if (isMobile) {
                                        setOpen(false)
                                    }
                                }}
                            >
                                <ListItemIcon
                                    sx={
                                        location.pathname === '/private/gestor/solicitacoesPendentes'
                                            ? { minWidth: 0, mr: open ? 3 : "auto", justifyContent: "center", color: "white", }
                                            : { minWidth: 0, mr: open ? 3 : "auto", justifyContent: "center" }
                                    }
                                >
                                    <PendingActionsIcon />
                                </ListItemIcon>
                                <ListItemText
                                    primary="Solicitações"
                                    sx={
                                        '/private/gestor/solicitacoesPendentes' === location.pathname
                                            ? { fontWeight: "bold", color: "white", opacity: open ? 1 : 0 }
                                            : { color: theme.palette.common.black, opacity: open ? 1 : 0 }
                                    }
                                />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding sx={{ display: "block" }}>
                            <ListItemButton
                                sx={
                                    '/private/gestor/todasReservas' === location.pathname
                                        ? {
                                            minHeight: 48, px: 2.5,
                                            justifyContent: open ? "initial" : "center",
                                            bgcolor: "#2A307D", borderRadius: "0 15px 15px 0",
                                            "&:hover": { bgcolor: "#2A307D" },
                                        }
                                        : { minHeight: 48, justifyContent: open ? "initial" : "center", px: 2.5 }
                                }
                                component={Link} to={'/private/gestor/todasReservas'}
                                onClick={() => {
                                    if (isMobile) {
                                        setOpen(false)
                                    }
                                }}
                            >
                                <ListItemIcon
                                    sx={
                                        location.pathname === '/private/gestor/todasReservas'
                                            ? { minWidth: 0, mr: open ? 3 : "auto", justifyContent: "center", color: "white", }
                                            : { minWidth: 0, mr: open ? 3 : "auto", justifyContent: "center" }
                                    }
                                >
                                    <EventIcon />
                                </ListItemIcon>
                                <ListItemText
                                    primary="Reservas"
                                    sx={
                                        '/private/gestor/todasReservas' === location.pathname
                                            ? { fontWeight: "bold", color: "white", opacity: open ? 1 : 0 }
                                            : { color: theme.palette.common.black, opacity: open ? 1 : 0 }
                                    }
                                />
                            </ListItemButton>
                        </ListItem>
                    </>
                }

                <hr />

                <ListItem disablePadding sx={{ display: "block" }}>
                    <ListItemButton
                        sx={{ minHeight: 48, justifyContent: open ? "initial" : "center", px: 2.5 }}
                        onClick={() => atualizaDados()}
                    >
                        <ListItemIcon
                            sx={{ minWidth: 0, mr: open ? 3 : "auto", justifyContent: "center" }}
                        >
                            <PersonIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary="Atualizar cadastro"
                            sx={{ color: theme.palette.common.black, opacity: open ? 1 : 0 }}
                        />
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding sx={{ display: "block" }}>
                    <ListItemButton
                        sx={{ minHeight: 48, justifyContent: open ? "initial" : "center", px: 2.5 }}
                        onClick={() => abreManual()}
                    >
                        <ListItemIcon
                            sx={{ minWidth: 0, mr: open ? 3 : "auto", justifyContent: "center" }}
                        >
                            <LibraryBooksIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary="Manual do Associado"
                            sx={{ color: theme.palette.common.black, opacity: open ? 1 : 0 }}
                        />
                    </ListItemButton>
                </ListItem>

                {/* Rota Sair */}
                <ListItem disablePadding sx={{ display: "block" }}>
                    <ListItemButton
                        sx={{ minHeight: 48, justifyContent: open ? "initial" : "center", px: 2.5 }}
                        onClick={handleDeslogar}
                    >
                        <ListItemIcon
                            sx={{ minWidth: 0, mr: open ? 3 : "auto", justifyContent: "center" }}
                        >
                            <LogoutIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary="Sair"
                            sx={{ color: theme.palette.common.black, opacity: open ? 1 : 0 }}
                        />
                    </ListItemButton>
                </ListItem>
            </List>

        </Drawer>
    )
}

export default SideBarBase

const drawerWidth = 240;

const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
}));
